import request from "@/utils/request";
import {baseURL} from "@/utils/getawayModule";

/***
 *
 * 获取球场列表 get
 * @param query 分页参数
 * @return request
 * */
export function getCourtList(query) {
    return request({
        url: `${baseURL.businessApi}/courts/back/list`,
        method: 'get',
        params: query
    })
}


/**
 * 根据id查询球场详情
 * @param id
 * @returns {AxiosPromise}
 */
export function getCourtDetails(id) {
    return request({
        url: `${baseURL.businessApi}/courts/back/details/${id}`,
        method: 'get'
    })
}

/**
 * 增加球场 post
 * @param data 增加的数据
 * @return request
 * */
export function addCourt(data) {
    return request({
        url: `${baseURL.businessApi}/courts`,
        method: 'post',
        data: data
    })
}

/**
 * 根据地址查询经纬度
 * @param query
 * @returns {AxiosPromise}
 */
export function getLngLatByAddr(query) {
    return request({
        url: `${baseURL.businessApi}/map/getLngLatByAddr`,
        method: 'get',
        params: query
    })
}



/**
 * 删除球场  delete
 * @param id 球场id
 * @return request
 * */
export function deleteCourt(id) {
    return request({
        url: `${baseURL.businessApi}/courts/${id}`,
        method: 'delete'
    })
}

/***
 * 修改球场 Post
 * @param id 要修改的球场id
 * @param data 修改的数据
 * @return request
 *
 * */
export function updateCourt(id, data) {
    return request({
        url: `${baseURL.businessApi}/courts/${id}`,
        method: 'post',
        data: data
    })
}

/**
 * 查询球场ID名称
 * @returns {AxiosPromise}
 */
export function getCourtName() {
    return request({
        url: `${baseURL.businessApi}/courts/getCourtName`,
        method: 'get',
    })
}
